// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2M08A","range":"MonthRangeSwitch_range__26Qa3","disabled":"MonthRangeSwitch_disabled__wzF5k"};